import React from 'react';
import { SectionLabel } from './ui/SectionLabel';
import { useLanguage } from '../contexts/LanguageContext';

export const Process: React.FC = () => {
  const { t } = useLanguage();
  const steps = t.process.steps;

  return (
    <section id="process" className="w-full py-32 px-6 max-w-7xl mx-auto border-x border-white/5 relative overflow-hidden">
      <div className="mb-20">
        <SectionLabel text={t.process.label} />
        <h2 className="text-3xl md:text-4xl text-white font-light">
          {t.process.title} <br/>
          <span className="text-zinc-500">{t.process.subtitle}</span>
        </h2>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-8 relative z-10">
        {/* Connecting line for desktop */}
        <div className="hidden md:block absolute top-12 left-0 w-full h-px bg-gradient-to-r from-emerald/0 via-emerald/20 to-emerald/0"></div>

        {steps.map((step) => (
          <div key={step.number} className="relative group">
             {/* Mobile connecting line */}
            <div className="md:hidden absolute left-[1.15rem] top-12 bottom-0 w-px bg-white/10"></div>

            <div className="flex flex-row md:flex-col items-start gap-6 md:gap-0">
                <div className="flex items-center gap-4 mb-6 bg-obsidian z-10 pr-4 md:pr-0">
                <span className="font-mono text-3xl md:text-4xl text-emerald/40 group-hover:text-emerald transition-colors duration-500">
                    {step.number}
                </span>
                <div className="hidden md:block h-px w-24 bg-white/10 group-hover:bg-white/20 transition-colors"></div>
                </div>
                
                <div>
                    <h3 className="text-xl text-white font-medium mb-4">{step.title}</h3>
                    <p className="text-mutedGray font-light text-sm leading-relaxed border-l border-white/5 pl-4 group-hover:border-emerald/50 transition-colors duration-300">
                    {step.description}
                    </p>
                </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};